import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate } from 'react-router-dom';
import { useTheme } from 'styled-components';

import SubAbasDemandasInformacoes from './subabasDemandasInformacoes';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import SubAbas from '../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { useStatusVersao } from '../../../../services/enum/useStatusVersao';
import { getNotaVersao } from '../../../../services/gestaoSisAF/notaVersaoSisafService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import { formataNomeMeioSiglas } from '../../../../utils/functions';
import {
  swal,
  swalAtualizacao,
  swalSave,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
} from '../../../../utils/swal';

//DADOS USUARIO
const user = getUser();
const userID = user.sub;
//const entity = ENTITY.ENTITY_Contratos;

export default function DemandasInformacoesFicha() {
  //PERMISSOES-MODULOS
  const papelUsuarioOptions = usePapelUsuario();
  const moduloUsuarioOptions = useModuloUsuario();
  // Obter o módulo
  const MODULO = Number(
    moduloUsuarioOptions.find((modulo) => modulo.label === 'Contratos')
      ?.value || '0',
  );

  // Verificar permissões para ações
  // const canDownload = isActionAllowed(MODULO, 'read', papelUsuarioOptions);
  //const canInsert = isActionAllowed(MODULO, 'create', papelUsuarioOptions);
  const canDelete = isActionAllowed(MODULO, 'delete', papelUsuarioOptions);
  const canSave = isActionAllowed(MODULO, 'update', papelUsuarioOptions);
  //PERMISSOES

  const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  //Dados do componente
  let logs = {};
  let subAbas = [];

  const statusVersao = useStatusVersao();

  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  const [formNotaVersao, setFormNotaVersao] = useState({
    usuarioId: userID,
    statusVersao: '',
    dataVersao: '',
    tagVersao: '',
    descricao: '',
    link: '',
    observacoes: '',
  });

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const registroData = await getNotaVersao(id);
      setLogData(registroData);
      setFormNotaVersao({
        usuarioId: userID,
        statusVersao: registroData.statusVersao,
        dataVersao: registroData.dataVersao,
        tagVersao: registroData.tagVersao,
        descricao: registroData.descricao,
        link: registroData.link,
        observacoes: registroData.observacoes,
      });
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //
  const [statusStyle, setStatusStyle] = useState<React.CSSProperties>({});
  useEffect(() => {
    const verde = '#abf3aba7';
    const vermelho = '#ffcecec3';
    const amarelo = '#faffb4dd';

    const status = String(formNotaVersao.statusVersao);

    const newStatusStyle = {
      backgroundColor:
        status === '1'
          ? amarelo
          : status === '2'
            ? verde
            : status === '3'
              ? vermelho
              : 'white',
    };

    setStatusStyle(newStatusStyle);
  }, [formNotaVersao.statusVersao]);

  const [isDateReadOnly, setIsDateReadOnly] = useState(true);
  useEffect(() => {
    if (
      formNotaVersao.statusVersao == '1' ||
      formNotaVersao.statusVersao == '3'
    ) {
      setIsDateReadOnly(true);
      setFormNotaVersao((prev) => ({
        ...prev,
        dataVersao: '',
      }));
    } else {
      setIsDateReadOnly(false);
    }
  }, [formNotaVersao.statusVersao]);

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID); // Chama a função para buscar dados quando o comp
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasDemandasInformacoes(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/daf/maisopcoes/notas/ficha/dadosgerais`,
      },
    ];
  }

  //Funções Handle
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;
    setFormNotaVersao((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.statusVersao) {
      errors.push('<b>Status da versão</b> é obrigatório.');
    }

    if (!form.tagVersao) {
      errors.push('Nome da <b>tag da versão</b> é obrigatório.');
    }

    if (!form.descricao) {
      errors.push('<b>Descrição</b> é obrigatório.');
    }

    if (form.statusVersao == '2' && form.dataVersao == '') {
      errors.push('<b>Data da versão</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalErro(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const handleCreate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formNotaVersao);
      if (!isFormValid) return;

      const formToSend = {
        ...formNotaVersao,
        statusVersao: Number(formNotaVersao.statusVersao),
        dataVersao: formNotaVersao.dataVersao
          ? formNotaVersao.dataVersao
          : null,
      };

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(
        `/api/notaversaosisaf/`,
        formToSend,
      );

      swalSave();
      setTimeout(
        () =>
          (window.location.href = `#/daf/maisopcoes/notas/ficha/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleUpdate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formNotaVersao);
      if (!isFormValid) return;

      const formToSend = {
        ...formNotaVersao,
        statusVersao: Number(formNotaVersao.statusVersao),
        dataVersao: formNotaVersao.dataVersao
          ? formNotaVersao.dataVersao
          : null,
      };

      const response = await httpClient.patch(
        `/api/notaversaosisaf/${fichaID}`,
        formToSend,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registro.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
      console.log(error.message);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) {
      return;
    }

    if (result) {
      try {
        await httpClient.delete(`/api/notaversaosisaf/${fichaID}`);
        swalDeleteConfirm();
        navigate('/daf/maisopcoes/notas');
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  const theme = useTheme();

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/home/demandasinformacoes"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <Log {...logs} />

          <BoxConteudo boxTitulo="Classificação da Demanda">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="200px">
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="Status"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="Nível de Criticidade"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>

              <CustomCol width="200px">
                <Input
                  name="dataVersao"
                  label="Data de Entrada"
                  value={formNotaVersao.dataVersao}
                  id="dataVersao"
                  onChange={handleChange}
                  type="date"
                  readonly={isDateReadOnly}
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="dataVersao"
                  label="Data de Saída"
                  value={formNotaVersao.dataVersao}
                  id="dataVersao"
                  onChange={handleChange}
                  type="date"
                  readonly={true}
                />
              </CustomCol>
              <CustomCol width="150px">
                <Input
                  name="link"
                  label="Permanência (dias)"
                  value={formNotaVersao.link}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly={true}
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="Possui SEI?"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>

              <CustomCol>
                <Input
                  name="link"
                  label="Nº Processo SEI"
                  value={formNotaVersao.link}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="numeroArp"
                  label="Documento SEI"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
            </CustomRow>

            {/* Denominação Genérica / Kit de Produto */}
            <CustomRow>
              <CustomCol width="250px">
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="Tipo de Demanda"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
              <CustomCol width="250px">
                <Input
                  name="numeroArp"
                  label="Nº da LAI/Nº Processo Judicial"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
              <CustomCol width="300px">
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="Demandante"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="numeroArp"
                  label="Outro"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly={true}
                />
              </CustomCol>
              <CustomCol width="190px">
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="UF do Demandante"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
              <CustomCol width="250px">
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="Grupo de Mídia"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
              <CustomCol>
                <Input
                  name="numeroArp"
                  label="Email Demandante"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly={true}
                />
              </CustomCol>
            </CustomRow>

            <CustomRow
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-start',
              }}
            >
              <CustomCol width="200px">
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="CGAFB"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="CGAFME"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="CGCEAF"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="CGFP"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="COFISC"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
              <CustomCol width="200px">
                <SelectInput
                  name="statusVersao"
                  options={statusVersao}
                  label="Gabinete"
                  value={formNotaVersao.statusVersao}
                  onChange={handleChange}
                  style={statusStyle}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          {/* Demanda */}
          <BoxConteudo boxTitulo="Demanda" fechado>
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol>
                <Input
                  name="numeroArp"
                  label="Título da Demanda"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>

              <CustomCol width="250px">
                <Input
                  name="numeroArp"
                  label="Link Documento"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formNotaVersao.observacoes}
                  label="Resumo da demanda"
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <Input
                  name="numeroArp"
                  label="Tags/Palavras-chaves"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Resposta" fechado>
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol>
                <Input
                  name="numeroArp"
                  label="Título da Resposta"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>

              <CustomCol width="250px">
                <Input
                  name="numeroArp"
                  label="Link Documento"
                  value={formNotaVersao.tagVersao}
                  id="tagVersao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formNotaVersao.observacoes}
                  label="Resumo da resposta"
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol>
                <Input
                  name="tags"
                  label="Responsáveis pela resposta"
                  value={formNotaVersao.observacoes}
                  id="tags"
                  onChange={handleChange}
                  readonly
                  type="textarea"
                />
              </CustomCol>
              <CustomCol
                width="100px"
                style={{ alignSelf: 'flex-end', marginBottom: '10px' }}
              >
                <CustomButton
                  label="Editar"
                  bgColor={theme.colors.amarelogov}
                  textColor="#ffffff" // Texto branco
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          {/* Observações */}
          <BoxConteudo boxTitulo="Observações" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formNotaVersao.observacoes}
                  label=""
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            deleteDisabled={!canDelete}
            onClickDelete={handleDelete}
            save
            saveDisabled={!canSave}
            onClickSave={handleUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
